const keyCode = {
    tab    : 9,
    enter  : 13,
    shift  : 16,
    escape : 27,
};

export default keyCode;
